import { Component, Host, h, Prop, State, Listen } from '@stencil/core';
import { Entry } from '../../../../types/site';

@Component({
  tag: 'sy-site-footer-list-collapse',
  styleUrl: 'sy-site-footer-list-collapse.scss',
  assetsDirs: ['assets'],
  shadow: true,
})

export class SySiteFooterListCollapse {
  /**
   * Sidebar link grid title
   */
  @Prop() entry: Entry;

  @State() isOpen = false;

  @Listen('syCollapseDidOpen')
  setOpenIcon(): void {
    this.isOpen = true;
  }

  @Listen('syCollapseDidClose')
  setClosedIcon(): void {
    this.isOpen = false;
  }

  render() {
    return (
      <Host>
        <div class="collapse">
          <div
            class="link footer-collapse"
          >
            <sy-text type="small">{this.entry.title}</sy-text>
            <sy-icon class={this.isOpen ? "open" : "close"} name="add" size={10}></sy-icon>
          </div>
          <sy-collapse trigger-by=".collapse">
            {this.entry.children[0].children ? (
              this.entry.children.map((child) => {
                return (
                  <div key={child.title}>
                    <sy-text type="small">{child.title}</sy-text>
                    <ul>
                      {child.children.map((item, index) => {
                        return (
                          <li key={index}>
                            <a
                              href={item.href}
                              class={{
                                link: true,
                              }}
                            >
                              {item.title}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })
            ) : (
              <ul>
                {this.entry.children.map((child) => {
                  return (
                    <li key={child.title}>
                      <a
                        href={child.href}
                        class={{
                          link: true,
                        }}
                      >
                        {child.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            )}
          </sy-collapse>
        </div>
      </Host >
    );
  }

}
